import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Select from 'react-select';
import LeaseApiService from '../../../services/apiService';
import { IoAdd } from "react-icons/io5";
import { GrDocumentUpdate } from "react-icons/gr";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { useCurrency } from '../../../../INVENTORY/Layouts/currencyContext';

const UnitDetailsEdt = ({ leaseData, rentPerAnum, periodFrom, periodTo, handleUnitPaymentPlan, transData, calculatedTotal, totalRent, editIndex, setEditIndex, totalVat, totalDiscount, dataList, setSelectedIndex, formData, setDeletedUnit, setFormData, taxCodeList, propertylist, setAdditionalCharges, setUntData, handleclearform, setDataList }) => {
    const [showUpdate, setShowUpdate] = useState(false);
    const [rentCheck, setRentCheck] = useState(false);
    const [unitList, setUnitList] = useState([]);
    const [unitRent, setUnitRent] = useState(true);
    const apiService = new LeaseApiService();
    const { currencyPrecision } = useCurrency();

    const handleAdd = async () => {
        const requiredFields = [
            { key: 'Property.label', message: 'Please Select Property' },
            { key: 'Unit.label', message: 'Please Select Unit No' },
        ];
        if (!transData?.noInstallment) {
            toast.warning(`Please Enter No of Installment`);
            return;
        }
        for (const field of requiredFields) {
            const keys = field.key.split('.');
            let value = formData;
            for (const key of keys) {
                value = value?.[key];
            }
            if (!value) {
                toast.warning(field.message);
                return;
            }
        }
        if (!dataList[0]?.Property?.label) {
            setDataList(prevEntries => prevEntries.slice(1));
        }
        if (editIndex !== null) {
            const updatedEntries = [...dataList];
            updatedEntries[editIndex] = formData;
            setDataList(updatedEntries);
            setEditIndex(null);
            handleclearform();
            handleUnitPaymentPlan(updatedEntries, transData.noInstallment)

        } else {
            setDataList((prev) => [...prev, formData]);
            const updatedEntries = [...dataList];
            updatedEntries[dataList?.length + 1] = formData;
            handleUnitPaymentPlan(updatedEntries, transData.noInstallment)
            handleclearform();
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append("DropdownFor", "LASerUnitNos");
        params.append("CascadValue", selectedOption?.value);
        const res = await apiService.getApiParamater(
            "GET_UNITNO_DROP",
            `?${params?.toString()}`
        );
        setUnitList(res?.data?.items);
        setFormData({
            ...formData,
            Property: selectedOption,
        });
    }
    const handleTaxChange = async (selectedOption) => {
        let discountPerc = parseFloat(formData?.FreeRent) || 0;
        let amount = parseFloat(formData?.rentForPeriod);
        // Calculate total amount

        const taxParam = new URLSearchParams();
        taxParam.append("Action", "GetTaxRecordIdByTaxName");
        taxParam.append("TaxDescription", selectedOption?.label);
        const taxrecord = await apiService.getApiParamater(
            "GET_UNITNO_DATA",
            `?${taxParam?.toString()}`
        );
        let recordId = taxrecord?.data?.result?.data?.RecordId;
        let Rate = taxrecord?.data?.result?.data?.Rate;
        let taxAmount = (amount * Rate) / 100;
        let totalAmount = (amount - discountPerc) + taxAmount;

        setFormData({
            ...formData,
            vatRecord: recordId,
            taxRate: Rate,
            total: totalAmount,
            taxCode: selectedOption,
            vat: taxAmount,
        });
    }
    const handleUnitChange = async (selectedOption) => {
        setFormData({
            ...formData,
            Unit: selectedOption,
        });
        const params = new URLSearchParams();
        params.append("Action", "GetUnitDetailsByUnitNo");
        params.append("PropertyNo", formData?.Property?.value);
        params.append("UnitRefNo", selectedOption?.value);
        params.append("CustomerType", "NoInternal");
        const res = await apiService.getApiParamater(
            "GET_UNITNO_DATA",
            `?${params?.toString()}`
        );
        setUntData(res?.data?.result?.data);
        let item = res?.data?.result?.data;
        const taxCode = taxCodeList?.find(
            (dep) => dep.text === item?.VatDescription
        );

        const additionalParam = new URLSearchParams();
        additionalParam.append("Action", "GetChargesDetails");
        additionalParam.append("RentPerAnnum", item?.Rent_Per_Annum);
        const Additionalres = await apiService.getApiParamater(
            "GET_UNITNO_DATA",
            `?${additionalParam?.toString()}`
        );
        setAdditionalCharges(Additionalres?.data?.result?.data);
        // const mergedData = { ...item, ...Additionalres?.data?.result?.data };
        // setAdditionalCharges(mergedData);
        const taxParam = new URLSearchParams();
        taxParam.append("Action", "GetTaxRecordIdByTaxName");
        taxParam.append("TaxDescription", item?.VatDescription);
        const taxrecord = await apiService.getApiParamater(
            "GET_UNITNO_DATA",
            `?${taxParam?.toString()}`
        );
        let recordId = taxrecord?.data?.result?.data?.RecordId;
        let Rate = taxrecord?.data?.result?.data?.Rate;

        const periodParam = new URLSearchParams();
        periodParam.append("Action", "GetRentforPeriod");
        periodParam.append("PeriodFrom", periodFrom);
        periodParam.append("PeriodTo", periodTo);
        periodParam.append("RentPerAnnum", item?.Rent_Per_Annum);
        const periodRes = await apiService.getApiParamater("GET_UNITNO_DATA", `?${periodParam?.toString()}`);
        let resPeriod = periodRes?.data?.result?.data
        let taxAmount = (resPeriod?.RentPerPeriod * Rate) / 100;
        let totalAmount = resPeriod?.RentPerPeriod + taxAmount;

        setFormData({
            ...formData,
            vatRecord: recordId,
            taxRate: Rate,
            Unit: selectedOption,
            noCommunity: "",
            rentPerAnum: item?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
            unitClass: item?.Unit_Class,
            type: item?.Unit_Type,
            rentForPeriod: resPeriod?.RentPerPeriod?.toFixed(currencyPrecision?.decimalNumbers),
            unitRefNo: item?.Ref_No,
            bedRooms: item?.Bedrooms === "0" ? "" : item?.Bedrooms,
            FreeRent: "",
            discountPerc: '',
            rentAmount: (resPeriod?.RentPerPeriod),
            totalArea: item?.Total_Area === "0" ? "" : item?.Total_Area,
            Landloard: item?.Landlord === "0" ? "" : item?.Landlord,
            taxCode: { label: taxCode?.text, value: taxCode?.value },
            category: item?.Unit_Category,
            vat: taxAmount,
            discount: 0,
            total: totalAmount,
            parkingNo: item?.ParkingNo === "0" ? "" : item?.ParkingNo,
            munAcNo: item?.MuncAcNo === "0" ? "" : item?.MuncAcNo,
            Parking: item?.Parking === "0" ? "" : item?.Parking,
        });
    }
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "rentForPeriod") {
            let newvalue = parseFloat(value) || 0;
            let taxCode = parseFloat(formData?.taxRate) || 0;
            let discountPerc = parseFloat(formData?.discountPerc) || 0;

            // Calculate discount and tax
            let discountAmount = (newvalue * discountPerc) / 100;
            let taxAmount = (newvalue * taxCode) / 100;

            // Calculate total amount
            let totalAmount = newvalue - discountAmount + taxAmount;

            setFormData({
                ...formData,
                rentForPeriod: newvalue,
                total: totalAmount,
                FreeRent: discountAmount,
                rentAmount: newvalue,
                vat: taxAmount,
            });
        } else if (name === "discountPerc") {
            let newvalue = parseFloat(value) || 0;
            let taxCode = parseFloat(formData?.taxRate) || 0;
            let amount = parseFloat(formData?.rentForPeriod) || 0;
            // Calculate discount and tax
            let discountAmount = (amount * newvalue) / 100;
            let taxAmount = (amount * taxCode) / 100;

            // Calculate total amount
            let totalAmount = (amount - discountAmount) + taxAmount;

            setFormData({
                ...formData,
                total: totalAmount,
                discountPerc: newvalue,
                FreeRent: discountAmount,
                vat: taxAmount,
                rentAmount: (amount - discountAmount),
            });
        } else if (name === "FreeRent") {
            let newvalue = parseFloat(value) || 0;
            let taxCode = parseFloat(formData?.taxRate) || 0;
            let amount = parseFloat(formData?.rentForPeriod) || 0;
            // Calculate discount and tax
            let taxAmount = (amount * taxCode) / 100;
            let discountAmountPerc = amount > 0 ? (newvalue / amount) * 100 : 0;

            // Calculate total amount
            let totalAmount = (amount - newvalue) + taxAmount;

            setFormData({
                ...formData,
                total: totalAmount,
                discountPerc: discountAmountPerc?.toFixed(currencyPrecision?.decimalNumbers),
                FreeRent: newvalue,
                rentAmount: (amount - newvalue),
                vat: taxAmount,
            });
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    }
    const handleEdit = async (index) => {
        let data = dataList[index]
        const params = new URLSearchParams();
        params.append("DropdownFor", "LASerUnitNos");
        params.append("CascadValue", data?.Property?.value);
        const res = await apiService.getApiParamater(
            "GET_UNITNO_DROP",
            `?${params?.toString()}`
        );
        setUnitList(res?.data?.items);
        setFormData(dataList[index]);
        setEditIndex(index);
    }
    const handleUpdate = () => {
        const updatedList = [...dataList];
        const oldUnit = updatedList[editIndex]; // previous data before update
        const newUnit = formData;

        // Check if the unit number has changed
        if (oldUnit.Unit.value !== newUnit.Unit.label) {
            setDeletedUnit(prev => [
                ...prev,
                {
                    recordId: leaseData?.recordId,
                    propertyNo: oldUnit.Property?.value || "",
                    unitNo: oldUnit.Unit?.label || "",
                    unitRefNo: oldUnit.unitRefNo || "",
                },
            ]);
        }

        // Update the list with the new data
        updatedList[editIndex] = { ...newUnit, selected: false };
        setDataList(updatedList);
        handleUnitPaymentPlan(updatedList, transData.noInstallment)
        // reset edit state
        setSelectedIndex(null);
        setEditIndex(null);
        setShowUpdate(false);
        handleclearform();
    };
    const handleDelete = (index) => {
        const updatedEntries = dataList.filter((_, i) => i !== index);
        setDataList(updatedEntries);
        if (editIndex === index) {
            setFormData({
                vatRecord: "",
                Property: [],
                Unit: [],
                noCommunity: "",
                rentPerAnum: "",
                unitClass: "",
                type: "",
                rentForPeriod: "",
                unitRefNo: "",
                bedRooms: "",
                FreeRent: "",
                discountPerc: "",
                totalArea: "",
                Landloard: "",
                taxCode: [],
                category: "",
                vat: "",
                discount: "",
                total: "",
                parkingNo: "",
                munAcNo: "",
                Parking: "",
                taxRate: "",
            });
            setEditIndex(null);
        }
    }
    return (
        <>
            <div className="cost-center-section my-3">
                <div
                    className="d-flex cursor-pointer slide-header"
                    onClick={() => setUnitRent(!unitRent)}
                >
                    <div className="h6 pt-1">Unit Rent Details</div>
                </div>
                <div className={`slide-content ${unitRent ? "open" : "closed"}`}>
                    <div
                        className={`border-box2 p-3 ${unitRent ? "slide-in" : "slide-out"
                            }`}
                    >
                        <div className="form-group grid-contain "
                        >
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Property
                                </label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                    value={formData.Property}
                                    options={propertylist?.map((cost) => ({
                                        value: cost?.value,
                                        label: cost?.text,
                                    }))}
                                    onChange={(selectedOption) =>
                                        handlePropertyChange(selectedOption)
                                    }
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Unit *
                                </label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                    value={formData.Unit}
                                    options={unitList?.map((cost) => ({
                                        value: cost?.value,
                                        label: cost?.text,
                                    }))}
                                    onChange={(selectedOption) =>
                                        handleUnitChange(selectedOption)
                                    }
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Munc No.community{" "}
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="noCommunity"
                                    value={formData.noCommunity}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Rent Per Anum
                                </label>
                                <input
                                    type="email"
                                    className="p-2 form-control w-75"
                                    name="rentPerAnum"
                                    value={formData.rentPerAnum}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Unit Class
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="unitClass"
                                    value={formData.unitClass}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Type
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="type"
                                    value={formData.type}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Rent For period
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="rentForPeriod"
                                    value={formData.rentForPeriod}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Unit Ref No.
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="unitRefNo"
                                    value={formData.unitRefNo}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Bed Room’s
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="bedRooms"
                                    value={formData.bedRooms}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Free Rent
                                </label>
                                <input
                                    type="number"
                                    className="p-2 form-control w-25"
                                    name="discountPerc"
                                    placeholder="%"
                                    value={formData.discountPerc}
                                    onChange={handleChange}
                                />
                                <input
                                    type="number"
                                    className="p-2 form-control w-50"
                                    name="FreeRent"
                                    placeholder="0.00"
                                    value={formData.FreeRent}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Landlord
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="Landloard"
                                    value={formData.Landloard}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Category
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="category"
                                    value={formData.category}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Tax Code *
                                </label>
                                <Select
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9,
                                    })}
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                            color: state.isFocused ? "#000 " : "#000",
                                            ":hover": {
                                                backgroundColor: "#F5F5F5",
                                                color: "#000 ",
                                            },
                                        }),
                                    }}
                                    className="w-75 p-0"
                                    value={formData.taxCode}
                                    options={taxCodeList?.map((cost) => ({
                                        value: cost?.value,
                                        label: cost?.text,
                                    }))}
                                    onChange={(selectedOption) =>
                                        handleTaxChange(selectedOption)
                                    }
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Total Area
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="totalArea"
                                    value={formData.totalArea}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex gap-4 center">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="rentCheck"
                                    style={{ width: "20px", height: "20px" }}
                                    name="rentCheck"
                                    checked={rentCheck}
                                    onChange={(e) => setRentCheck(e.target.checked)}
                                />
                                <label className="text-danger">Rent-Non Leasing</label>
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    VAT
                                </label>
                                <input
                                    type="text"
                                    className="p-2 form-control w-75"
                                    name="vat"
                                    value={formData.vat}
                                    readOnly
                                />
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Munc / Ac No.{" "}
                                </label>
                                <input
                                    type="number"
                                    className="p-2 form-control w-75"
                                    name="munAcNo"
                                    value={formData.munAcNo}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="d-flex center">
                                <h6 className="text-danger text-bold">Unit Rent</h6>
                            </div>
                            <div className="d-flex">
                                <label
                                    htmlFor="validationCustom01"
                                    className="form-label pt-1 start"
                                >
                                    Total
                                </label>
                                <input
                                    type="number"
                                    className="p-2 form-control w-75"
                                    name="total"
                                    value={formData.total}
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex">
                {editIndex !== null ?
                    <div className="mainbtnSecondary flex-end gap-2" onClick={handleUpdate}>
                        <GrDocumentUpdate color="#fff" className="center mt-2 mx-2" />
                        <div className="center">Update</div>
                    </div> :
                    <div className="mainbtn end center gap-2" onClick={handleAdd} disabled={showUpdate}>
                        <IoAdd color="#fff" className="center mx-2" />
                        <div className="center">Add</div>
                    </div>
                }
            </div>
            <div>
                <div
                    className="table-container my-3"
                    style={{ overflowX: "auto", height: "400px" }}
                >
                    <table>
                        <thead className="dynoTable">
                            <tr>
                                <th>Action</th>
                                <th>Property</th>
                                <th>Unit No.</th>
                                <th>Unit Ref No.</th>
                                <th>Unit Class</th>
                                <th>Area</th>
                                <th>Discount</th>
                                <th>Tax</th>
                                <th>Rent</th>
                                <th>VAT</th>
                                <th>Total</th>
                                <th>Rent Per Anum</th>
                                <th>Bed Room’s</th>
                                <th>Unit Type</th>
                                <th>Unit Category</th>
                                <th>Parking No</th>
                                <th>Munc A/c No.</th>
                                <th>Munc No. Community</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(dataList) &&
                                dataList?.map((data, index) => (
                                    <tr key={index}>
                                        <td className='gap-3 d-flex'>
                                            {!data.Property?.label ?
                                                <input className="p-1" disabled style={{ width: "80px" }} /> :
                                                <>
                                                    <div className='pt-2' onClick={() => handleDelete(index)}>
                                                        <MdDelete size={25} />
                                                    </div>
                                                    <div className='pt-2' onClick={() => handleEdit(index)}>
                                                        <FiEdit size={25} />
                                                    </div>
                                                </>
                                            }
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.Property?.label || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.Unit.label || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.unitRefNo || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.unitClass || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={Number(data.totalArea)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={Number(data.FreeRent)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.taxCode?.label || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={Number(data.rentAmount)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={Number(data.vat)?.toFixed(currencyPrecision?.decimalNumbers) || 0}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={Number(data.total)?.toFixed(currencyPrecision?.decimalNumbers) || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={Number(data.rentPerAnum)?.toFixed(currencyPrecision?.decimalNumbers)}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.bedRooms || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.type || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.category || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.parkingNo || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.munAcNo || ""}
                                                disabled
                                                style={{ width: "130px" }}
                                            />
                                        </td>
                                        <td className="m-0 p-0">
                                            <input
                                                className="p-1"
                                                value={data.noCommunity || ""}
                                                disabled
                                            />
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-between boxs">
                    <div className="d-flex gap-2">
                        <div className="totalhead center">Total Units</div>
                        <div className="field">{dataList?.length || "---"}</div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="totalhead center">Discount</div>
                        <div className="field">{`${totalDiscount}` || "---"}</div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="totalhead center">Vat Total</div>
                        <div className="field">{totalVat || "---"}</div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="totalhead center">Rent Total</div>
                        <div className="field">{totalRent || "---"}</div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="totalhead center">Total Amount</div>
                        <div className="field">{calculatedTotal || "---"}</div>
                    </div>
                    <div className="d-flex gap-2">
                        <div className="totalhead center">Rent Per Anum Total</div>
                        <div className="field">{rentPerAnum || "---"}</div>
                    </div>
                </div>
            </div>
        </>

    );
};
export default UnitDetailsEdt;
